export default new class Header {
    constructor() {
      this.init();
    }
  
    init() {
      const items = document.querySelectorAll('.faq__item');

      items.forEach(item => {
        const button = item.querySelector('.faq__item_button');        

        button.addEventListener('click', (e) => {
            e.preventDefault();

            if (!item.classList.contains('faq__item--active')) {
                const activeItem = document.querySelector('.faq__item--active');
                activeItem.classList.remove('faq__item--active');
                item.classList.add('faq__item--active');  
                this.init();  
            }
        })

      })
    }
  }